export default "__VITE_ASSET__BynlhxqC__"